// import hasSampledVariantSelector from 'modules/variant/redux/selectors/has-sampled'

import logConversionEventHandleAddCartAction from 'modules/cart/redux/actions/toggle-add-remove/actions/handle-add/actions/log-conversion-event'
import addItemCartAction from 'modules/cart/redux/actions/add-item'
import logUtil from 'utils/log'
import beforeAddCartAction from 'modules/cart/redux/actions/toggle-add-remove/actions/handle-add/actions/before-add'
import afterAddCartAction from 'modules/cart/redux/actions/toggle-add-remove/actions/after-add'

const ANALYTICS_EVENT = {
  ADD_TO_CART: 'ADD_TO_CART',
  ADD_SUBSCRIPTION_TO_CART: 'ADD_SUBSCRIPTION_TO_CART',
  ADD_STORE_CREDIT: 'ADD_STORE_CREDIT',
  ADD_FULL_SIZE_CONVERSION_TO_CART: 'ADD_FULL_SIZE_CONVERSION_TO_CART'
}

/**
 * @param {handleAddCartActionProps} props
 * @returns {(function(*, *): Promise<undefined|{wasRemoved: *, wasAdded}>)|*}
 */
export default function handleAddCartAction (props) {
  return async (dispatch, getState) => {
    const {
      variantId,
      onClickAdd,
      logEvent,
      isGiftCard,
      subscriptionSellingPlanId,
      productVariant,
      shouldShowFullSizeConversion
    } = props

    logUtil('handleAddCartAction').debug(`[start] variantId=${variantId} props=`, props)

    const res = dispatch(beforeAddCartAction(props))
    if (!res) {
      logUtil('handleAddCartAction').debug('[noop] don\'t add to cart')
      return
    }

    if (isGiftCard) {
      logEvent(ANALYTICS_EVENT.ADD_STORE_CREDIT)
    } else if (shouldShowFullSizeConversion) {
      logEvent(ANALYTICS_EVENT.ADD_FULL_SIZE_CONVERSION_TO_CART)
    } else {
      logEvent(ANALYTICS_EVENT.ADD_TO_CART)
    }

    onClickAdd?.(variantId)

    const options = {}
    if (subscriptionSellingPlanId) {
      options.selling_plan = subscriptionSellingPlanId
      logEvent(ANALYTICS_EVENT.ADD_SUBSCRIPTION_TO_CART)
    }

    const state = getState()
    await dispatch(
      addItemCartAction({
        variantId,
        productVariant,
        options,
        shouldAddLocally: (
          !subscriptionSellingPlanId &&
          !isGiftCard
        )
      })
    )

    dispatch(afterAddCartAction({ previousState: state }))

    dispatch(
      logConversionEventHandleAddCartAction({
        productVariant,
        variantId
      })
    )
  }
}
